//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    therapeut: {
      type: Object,
      required: true,
    },
  },
  computed: {
    naam() {
      let title = '';
      switch (this.therapeut.geslacht) {
        case 'Man':
          title = 'Dhr. ';
          break;
        case 'Vrouw':
          title = 'Mvr. ';
          break;
      }
      return title +
        (this.therapeut.voorletters ?? this.therapeut.voornaam[0] + '.') +
        (this.therapeut.tussenvoegsel ? ` ${this.therapeut.tussenvoegsel} ` : ' ') +
        (this.therapeut.achternaam);
    },
  },
};
